var module = angular.module('octopusApp.projects');

module.directive('portMapping', function($timeout, octopusLog) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/actions/docker_run/port-mapping.html',
        scope: {
            action: '=',
            project: '=',
            localNames: '='
        },
        controller: function() {
            var vm = this;

            vm.newHost = "";
            vm.newContainer = "";
            vm.addPortMapping = addPortMapping;
            vm.portMappings = [];
            vm.removePortMapping = removePortMapping;

            function addPortMapping() {
                if (_.any(vm.portMappings, function (mapping) {
                        return mapping.container === vm.newContainer;
                    })) {
                    octopusLog.log("Mapping to that container port already exists.. Try again");
                    return;
                }

                var pm = new PortMapping(vm.newHost, vm.newContainer, true);
                vm.portMappings.push(pm);
                vm.newHost = "";
                vm.newContainer = "";
                pm.commitEdit();
            }

            function removePortMapping(mapping){
                var idx = vm.portMappings.indexOf(mapping);
                if (idx >= 0) {
                    vm.portMappings.splice(idx, 1);
                }
                setProperties();
            }

            function PortMapping(host, container) {
                var self = {
                    container: container,
                    editContainer: container,
                    host: host,
                    editHost: host,
                    isEditing: false
                };

                self.formatted = formatMapping();
                self.commitEdit = commitEdit;
                self.cancelEdit = cancelEdit;

                function cancelEdit() {
                    self.editContainer = self.container;
                    self.editHost = self.host;
                    self.isEditing = false;
                }

                function commitEdit() {
                    self.container = self.editContainer;
                    self.host = self.editHost;
                    self.isEditing = false;
                    self.formatted = formatMapping();
                    setProperties();
                }

                function formatMapping(){
                    if (!self.host) {
                        // containerPort
                        return "<b>Container: </b>" + self.container;
                    }
                    return "<b>Host: </b>"+ self.host +" : <b>Container: </b>" + self.container;
                }
                return self;
            }

            function setProperties(){
                vm.action.Properties["Octopus.Action.Docker.PortMapping"] =  JSON.stringify(vm.portMappings.reduce(function(obj, mapping) {
                    obj[mapping.container] = mapping.host;
                    return obj;
                }, {}));
            }

            function init() {
                var json = vm.action.Properties["Octopus.Action.Docker.PortMapping"];
                if(!!json) {
                    try {
                        var obj = JSON.parse(json);
                        vm.portMappings = _.map(obj, function (host, container) {
                            return new PortMapping(host, container);
                        });

                    } catch (err) {
                        console.error(err);
                    }
                }
            }

            init();
        },
        controllerAs: 'vm',
        bindToController: true
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_run/port-mapping.js
// module id = 4557920614296592
// module chunks = 1